import React from 'react';
import ReactDOM from 'react-dom';
import App from "./App";
import AmplifyConfig from "./apis/amplify/amplifyConfig";
// import registerServiceWorker from "./serviceWorker";
import registerValidators from './util/validators';

registerValidators();

AmplifyConfig.init();
// registerServiceWorker();

//TODO: Change
const ENV = 'dev';
((log) => {
    console.log = (...args) => {
        if (ENV === 'dev') {
            log(...args)
        }
    };
})(console.log);

ReactDOM.render(<App/>, document.getElementById('root'));
